import type { FontFaceDescriptors } from 'css-font-loading-module';

export interface FontType {
    family: string;
    source: string;
    descriptors?: FontFaceDescriptors;
}

export type Suffix = 'primary' | 'secondary';

export const PRIMARY_FONT_FAMILY = 'Roboto' as const;
// export const SECONDARY_FONT_FAMILY = 'Roboto Condensed' as const;

export const fontExtensions = ['.woff2', '.woff', '.ttf'] as const;

function makeFontSource(path: string): string {
    return fontExtensions.map(ext => `url(${path}${ext})` as const).join(`, `);
}

function makeFontType(
    family: string,
    path: string,
    descriptors: FontFaceDescriptors
): FontType {
    return {
        family,
        source: makeFontSource(path),
        descriptors,
    };
}

export const PRIMARY_FONTS = ['400', '500', '700', '900'].map(weight =>
    makeFontType(
        PRIMARY_FONT_FAMILY,
        `assets/fonts/roboto-lc/roboto-lc-${weight}`,
        {
            style: 'normal',
            weight,
        }
    )
) as Tuple<FontType, 4>;

// export const SECONDARY_FONTS = ['400', '700'].map(weight =>
//     makeFontType(
//         SECONDARY_FONT_FAMILY,
//         `assets/fonts/roboto-condensed-lc/roboto-condensed-lc-${weight}`,
//         {
//             style: 'normal',
//             weight,
//         }
//     )
// ) as Tuple<FontType, 2>;

export function setFontToCssVar(font: string, suffix: Suffix): void {
    document.documentElement.style.setProperty(
        `--app-font-family-${suffix}`,
        `${font}, sans-serif`
    );
}

class DefaultFontMappingBySuffix implements Record<Suffix, unknown> {
    primary = [PRIMARY_FONT_FAMILY, PRIMARY_FONTS] as const;
    secondary = [PRIMARY_FONT_FAMILY, PRIMARY_FONTS] as const;
}

export const DEFAULT_FONT_MAPPING_BY_SUFFIX = new DefaultFontMappingBySuffix();
